export default __webpack_public_path__ + "static/media/happy_icon.5e7e83ed.svg";